/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, createRef, Fragment } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from './fields/fieldSelect';
import Input from './fields/fieldInput';
import ModalCustom from '../design/shared/modal';
import { Error } from '../design/elements';
import { ModalFormWrapper } from './css';
import { Button } from '@telus-uds/components-web';
import ErrorMessage from '../errorMessage';
import {
  keyDevices,
  keySpareDevices,
  keyDevicesWereChanged,
  fieldPayment,
  paymentTypeUpfront,
  paymentTypeEasyPayment,
  fieldAvailableDiscountsAndPromotions,
  keyBusinessAppPlans,
  fieldProductNameBA,
  fieldGoogleProductEditionsBA,
  fieldESChatProductEditionsBA,
  fieldMicrosoftProductEditionsBA,
  fieldTermProductBA,
  fieldDiscountedPricing
} from '../utils/constant';
import { promoDeviceRate, hwcPromoDeviceRates } from '../utils/rates';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import request from '../utils/request';
import stringInterpolation from '../utils/stringInterpolation';
import {
  fetchAndFilterDevices,
  calculateMaxDevices,
  calculateCurrentDevices,
  calculateCurrentTotalDevices
} from './utils/deviceFiltering';
import { checkHwcAllowance } from './utils/hwcEligibility';

const ModalForm = ({
  fields,
  formFields,
  setFormFields,
  dueNow,
  setDueNow,
  dueMonthly,
  setDueMonthly,
  open,
  header,
  onClose,
  setIsFormTouched,
  setIsFormValidated,
  orderData
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: {
      yes,
      valueEasyPayment,
      valuePaymentUpfront,
      valueNinetyNineCentDevicePromo,
      valueHardwareCreditPromo,
      devicePolycomVVX150,
      devicePolycomVVX250,
      deviceCisco7841,
      deviceYealinkT48U,
      deviceYealinkT48UOld,
      deviceYealinkT34W,
      deviceYealinkT34WOld,
      deviceYealinkT33G,
      deviceYealinkT33GOld,
      valueUpfront,
      valueMonthly,
      value12Upfront,
      value12Monthly,
      value36Upfront,
      value36Annual,
      value36Monthly,
      value24Monthly
    },
    modalForm: {
      fieldRequiredMessage,
      modalFormDevices,
      maxHwcDevicesErrorMessage,
      hwcAllowanceExhaustedMessage
    },
    formButtons: { saveButtonLabel },
    quoteForm: { promoLabel, hwcPromoLabel },
    productInOrderForOptions: {
      googleWorkspace,
      microsoft365,
      esChat,
      appHelpValueAddedService,
      googleWorkspaceBusiness,
      googleWorkspaceEnterprise,
      googleWorkspaceFrontline,
      googleWorkspaceEducation,
      googleWorkspaceAddons
    },
    orderRequestTypeBA: { existingAppService },
    microsoft365PlanOptions: {
      microsoftAppHelpInstallation,
      microsoftAppHelpEmailOneTime,
      microsoftAppHelpEmailMonthly
    },
    googlePlanOptions: {
      googleWorkspaceStarter,
      googleWorkspaceBusinessStandard,
      googleWorkspaceBusinessPlus,
      googleWorkspaceEnterpriseEssentials,
      googleWorkspaceEnterpriseEssentialsPlus,
      googleWorkspaceEnterpriseStarter,
      googleWorkspaceEnterpriseStandard,
      googleWorkspaceEnterprisePlus,
      googleWorkspaceFrontlineStarter,
      googleWorkspaceFrontlineStandard,
      googleWorkspaceEducationPlus,
      googleWorkspaceEducationStandard,
      googleWorkspaceEducationTeachingLearningUpgrade,
      geminiEducation,
      geminiEducationPremium,
      endpointEducationUpgrade,
      googleWorkspaceArchiveBusinessStarter,
      googleWorkspaceArchiveBusinessStandard,
      googleWorkspaceArchiveBusinessPlus,
      googleWorkspaceArchiveEnterpriseStandard,
      googleWorkspaceArchiveEnterprisePlus,
      googleWorkspaceEnterpriseDataRegions,
      cloudIdentityPremium,
      googleVault,
      googleWorkspaceStorage10TB,
      googleWorkspaceStorage100GB,
      googleWorkspaceStorage1TB,
      appSheetCore,
      appSheetEnterprisePlus,
      appSheetEnterprisePlusExternal,
      googleWorkspaceAssuredControlPlus,
      googleColabPro,
      googleColabProPlus,
      googleChatInterop,
      googleG_SuiteSetup,
      googleEmailOneTime,
      googleEmailMonthly
    }
  } = localizedStrings;
  const hwcContext = { valuePaymentUpfront };

  const nonMicrosoftOptions = [
    microsoftAppHelpInstallation,
    microsoftAppHelpEmailOneTime,
    microsoftAppHelpEmailMonthly
  ];
  const googleBusinessOptions = [
    googleWorkspaceStarter,
    googleWorkspaceBusinessStandard,
    googleWorkspaceBusinessPlus,
    googleWorkspaceArchiveBusinessStarter,
    googleWorkspaceArchiveBusinessStandard,
    googleWorkspaceArchiveBusinessPlus
  ];
  const googleEnterpriseOptions = [
    googleWorkspaceEnterpriseEssentials,
    googleWorkspaceEnterpriseEssentialsPlus,
    googleWorkspaceEnterpriseStarter,
    googleWorkspaceEnterpriseStandard,
    googleWorkspaceEnterprisePlus,
    googleWorkspaceArchiveEnterpriseStandard,
    googleWorkspaceArchiveEnterprisePlus,
    googleWorkspaceEnterpriseDataRegions
  ];
  const googleFrontlineOptions = [
    googleWorkspaceFrontlineStarter,
    googleWorkspaceFrontlineStandard
  ];
  const googleEducationOptions = [
    googleWorkspaceEducationPlus,
    googleWorkspaceEducationStandard,
    googleWorkspaceEducationTeachingLearningUpgrade,
    geminiEducation,
    geminiEducationPremium,
    endpointEducationUpgrade
  ];
  const googleAddonsOptions = [
    cloudIdentityPremium,
    googleVault,
    googleWorkspaceStorage10TB,
    googleWorkspaceStorage100GB,
    googleWorkspaceStorage1TB,
    appSheetCore,
    appSheetEnterprisePlus,
    appSheetEnterprisePlusExternal,
    googleWorkspaceAssuredControlPlus,
    googleColabPro,
    googleColabProPlus,
    googleChatInterop
  ];
  const nonGoogleOptions = [
    googleG_SuiteSetup,
    googleEmailOneTime,
    googleEmailMonthly
  ];
  const [modalFormFields, setModalFormFields] = useState();
  const [isPaymentLocked, setIsPaymentLocked] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [
    esChatProductEditionsBAOptions,
    setESChatProductEditionsBAOptions
  ] = useState([]);
  const [filteredDeviceOptions, setFilteredDeviceOptions] = useState([]);
  const [isLoadingDevices, setIsLoadingDevices] = useState(false);
  const key = header === modalFormDevices ? keyDevices : keySpareDevices;

  // Clear form errors when modal opens
  useEffect(() => {
    if (open) {
      setFormErrors({});
    }
  }, [open]);
  const valueBAProductSelected = _.get(orderData, 'productInOrderFor', '');

  // Load filtered devices from API
  const loadFilteredDevices = async () => {
    setIsLoadingDevices(true);
    try {
      // Determine modal type based on header text
      // Compare with localized modalFormDevices to work with both English and French
      let modalType = 'addDevices'; // default
      if (header === modalFormDevices) {
        modalType = 'addDevices';
      } else {
        // If header is not the primary devices modal, it's spare devices
        // This works for both English ("Add spare device(s)") and French ("Appareils additionnels")
        modalType = 'addSpareDevices';
      }

      const devices = await fetchAndFilterDevices(
        modalType,
        orderData,
        formFields,
        hwcContext
      );
      setFilteredDeviceOptions(devices);
    } catch (error) {
      setFilteredDeviceOptions([]);
    } finally {
      setIsLoadingDevices(false);
    }
  };

  const getTheUpdatedValues = async result => {
    const googleKeyIndex = fields.findIndex(
      item => item.fields.name === fieldGoogleProductEditionsBA
    );
    const microsoftKeyIndex = fields.findIndex(
      item => item.fields.name === fieldMicrosoftProductEditionsBA
    );
    const esChatKeyIndex = fields.findIndex(
      item => item.fields.name === fieldESChatProductEditionsBA
    );

    if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === googleWorkspace &&
      microsoftKeyIndex !== -1 &&
      esChatKeyIndex !== -1
    ) {
      // delete microsoft question //
      delete result.microsoftProductEditionsBA;
      fields.splice(microsoftKeyIndex, 1);
      // delete eschat question //
      delete result.esChatProductEditionsBA;
      fields.splice(esChatKeyIndex - 1, 1);
    } else if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === microsoft365 &&
      googleKeyIndex !== -1 &&
      esChatKeyIndex !== -1
    ) {
      // delete google question //
      delete result.googleProductEditionsBA;
      fields.splice(googleKeyIndex, 1);
      // delete eschat question //
      delete result.esChatProductEditionsBA;
      fields.splice(esChatKeyIndex - 1, 1);
    } else if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === esChat &&
      microsoftKeyIndex !== -1 &&
      googleKeyIndex !== -1
    ) {
      // delete microsoft question //
      delete result.microsoftProductEditionsBA;
      fields.splice(microsoftKeyIndex, 1);
      // delete google question //
      delete result.googleProductEditionsBA;
      fields.splice(googleKeyIndex - 1, 1);
    }

    if (orderData.productInOrderFor === esChat) {
      if (fields[1].fields.name === 'esChatProductEditionsBA') {
        if (formFields[fieldDiscountedPricing].value !== yes) {
          if (esChatProductEditionsBAOptions.length === 0) {
            setESChatProductEditionsBAOptions(fields[1].fields.options);
          }
          fields[1].fields.options =
            esChatProductEditionsBAOptions.length === 0
              ? fields[1].fields.options.slice(0, 2)
              : esChatProductEditionsBAOptions.slice(0, 2);
        } else if (esChatProductEditionsBAOptions.length > 0) {
          fields[1].fields.options = esChatProductEditionsBAOptions;
        }
      }
    }

    if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === microsoft365
    ) {
      // Get product categories from DB
      const categories = await request.get('/products/categories');
      if (categories && categories.data) {
        fields[0].fields.label = 'Category';
        fields[0].fields.options = categories.data.map(i => ({
          fields: {
            value: i.id,
            label: i.name
          }
        }));
      }

      // Get products from DB
      const products = await request.get('/products');
      if (products && products.data) {
        fields[1].fields.options = products.data.map(i => ({
          fields: { ...i }
        }));
      }
    }

    setModalFormFields(result);
    setIsPaymentLocked(false);
  };

  const setDefaultFields = () => {
    const result = {};

    fields.forEach(item => {
      const {
        fields: { name, value, required }
      } = item;
      const ref = createRef();
      result[name] = { ref, value, required };
    });

    if (orderData.type === 'BA') {
      getTheUpdatedValues(result);
    } else {
      setModalFormFields(result);
      setIsPaymentLocked(false);
    }
  };

  useEffect(() => {
    setDefaultFields();
  }, []);

  // Load filtered devices when modal opens and form fields change
  useEffect(() => {
    // Load devices for any modal that opens (both main devices and spare devices)
    if (open) {
      loadFilteredDevices();
    }
  }, [open, orderData, formFields, header]);

  // Update modal form fields when filtered devices change
  useEffect(() => {
    if (filteredDeviceOptions.length > 0 && modalFormFields) {
      // Update the device field options in modal form fields
      const updatedFields = { ...modalFormFields };
      if (updatedFields.device) {
        updatedFields.device.options = filteredDeviceOptions;
      }
      setModalFormFields(updatedFields);
    }
  }, [filteredDeviceOptions]);

  useEffect(() => {
    if (
      formFields[keyBusinessAppPlans] &&
      formFields[keyBusinessAppPlans].length > 0
    ) {
      const dueNowCount = formFields[keyBusinessAppPlans].reduce(
        (acc, item) => {
          acc += item.oneTimeCharges * item.quantity || 0;
          return acc;
        },
        0
      );
      const monthlyCount = formFields[keyBusinessAppPlans].reduce(
        (acc, item) => {
          acc += item.monthlyCharges * item.quantity || 0;
          return acc;
        },
        0
      );
      setDueNow(dueNowCount);
      setDueMonthly(monthlyCount);
    }
  }, []);

  useEffect(() => {
    if (open) {
      setDefaultFields();
    }
  }, [open]);

  const getErrors = () => {
    const result = { ...formErrors };

    fields.forEach(item => {
      const {
        fields: { ref, name, required, fieldValidation }
      } = item;
      const fieldValue = modalFormFields[name].value;

      if (required && !fieldValue) {
        result[name] = { text: fieldRequiredMessage, ref };
      } else {
        delete result[name];
      }

      if (fieldValidation) {
        const {
          errorMessage,
          logic,
          value: expectedValue
        } = fieldValidation.fields;
        let hasError = false;
        switch (logic) {
          case 'equal':
            // eslint-disable-next-line eqeqeq
            hasError = expectedValue.split('|').includes(fieldValue);
            break;
          case 'regex':
            {
              const regexLogic = new RegExp(expectedValue);
              hasError = regexLogic.test(fieldValue);
            }
            break;
          case 'gt':
            hasError = +fieldValue > +expectedValue;
            break;
          case 'gte':
            hasError = +fieldValue >= +expectedValue;
            break;
          case 'lt':
            hasError = +fieldValue < +expectedValue;
            break;
          default:
        }
        if (hasError) result[name] = { text: errorMessage, ref };
      }
    });
    /** Removing the term field for ESChat as it's not available for it */
    if (orderData.productInOrderFor === esChat) delete result.termProductBA;

    return result;
  };

  const getItemPrices = (name, value) => {
    const result = fields.find(item => item.fields.name === name);
    if (typeof result === 'undefined') return null;
    const {
      fields: { options }
    } = result;
    if (typeof options === 'undefined') return null;
    const option = options.find(item => item.fields.value === value);
    if (typeof option === 'undefined') return null;

    const {
      fields: {
        price,
        monthlyPayment,
        price12,
        monthlyPayment12,
        monthlyPayment24,
        price36,
        annualPayment36,
        monthlyPayment36
      }
    } = option;

    return {
      price,
      monthlyPayment,
      price12,
      monthlyPayment12,
      monthlyPayment24,
      price36,
      annualPayment36,
      monthlyPayment36
    };
  };

  const validateSeatLimit = (currentModalFields = modalFormFields) => {
    // Skip validation for Business Apps
    if (orderData.type === 'BA') return;

    if ((key === keyDevices || key === keySpareDevices) && currentModalFields) {
      const { device, quantity } = currentModalFields;
      if (device && device.value && quantity) {
        let maxDevices;
        let currentDevices;
        let currentTotalDevices;

        try {
          maxDevices = calculateMaxDevices(formFields, orderData);
        } catch (error) {
          maxDevices = 0;
        }

        try {
          currentDevices = calculateCurrentDevices(formFields);
        } catch (error) {
          currentDevices = 0;
        }

        try {
          // For spare devices, we need to include the current device being added in the calculation
          if (key === keySpareDevices) {
            const currentSpareDevices = (
              formFields[keySpareDevices] || []
            ).reduce((acc, item) => acc + (item.quantity || 0), 0);
            currentTotalDevices = currentDevices + currentSpareDevices;
          } else {
            currentTotalDevices = calculateCurrentTotalDevices(formFields);
          }
        } catch (error) {
          currentTotalDevices = currentDevices;
        }

        const maxTotalDevices = maxDevices * 4; // Spare devices can be up to 4x the seat count
        const newQuantity = Number(quantity.value) || 0;

        // A pending HWC add must also fit the HWC allowance before a stale error is cleared
        const isPendingHwcDevice =
          key === keyDevices && Boolean(device.hwcEligible);
        const isHwcAllowanceValid =
          !isPendingHwcDevice ||
          !checkHwcAllowance(formFields, orderData, hwcContext, {
            additionalQuantity: newQuantity
          }).wouldExceed;

        let totalDevicesAfterAdd;
        let isValid = false;

        if (key === keyDevices) {
          // For primary devices, check against seat limit
          // In modal, we're always adding a new device, so just add to current
          totalDevicesAfterAdd = currentDevices + newQuantity;
          isValid = totalDevicesAfterAdd <= maxDevices;
        } else if (key === keySpareDevices) {
          // For spare devices, check against total device limit (4x seat count)
          // In modal, we're always adding a new device, so just add to current total
          totalDevicesAfterAdd = currentTotalDevices + newQuantity;
          isValid = totalDevicesAfterAdd <= maxTotalDevices;
        }

        if (isValid && isHwcAllowanceValid && newQuantity > 0) {
          // Clear seat validation error if quantity is now valid
          setFormErrors(prevErrors => {
            if (prevErrors.seatValidation) {
              const newErrors = { ...prevErrors };
              delete newErrors.seatValidation;
              return newErrors;
            }
            return prevErrors;
          });
        }
      }
    }
  };

  const onChange = e => {
    const {
      target: { name, value }
    } = e;
    const newFields = { ...modalFormFields };
    const itemPrices = getItemPrices(name, value);
    const data = itemPrices ? { value, ...itemPrices } : { value };
    newFields[name] = { ...newFields[name], ...data };

    // Special handling for device selection to ensure pricing is properly set
    if (name === 'device') {
      // Find the selected device from filtered options
      const selectedDevice = filteredDeviceOptions.find(
        device => device.fields.value === value
      );

      if (selectedDevice) {
        // Set the pricing information directly from the device data
        newFields[name] = {
          ...newFields[name],
          value,
          price: selectedDevice.fields.price,
          monthlyPayment: selectedDevice.fields.monthlyPayment,
          deviceSku: selectedDevice.fields.deviceSku,
          deviceType: selectedDevice.fields.deviceType,
          familyType: selectedDevice.fields.familyType,
          hwcEligible: selectedDevice.fields.hwcEligible
        };
      }
    }

    setModalFormFields(newFields);

    // Validate seat limit when quantity or device changes (only for non-BA orders)
    if ((name === 'quantity' || name === 'device') && orderData.type !== 'BA') {
      // Use setTimeout to ensure state is updated before validation
      setTimeout(() => {
        validateSeatLimit(newFields);
      }, 0);
    }
  };

  const getDevicePromoPrices = (promo, deviceName) => {
    if (promo.includes(valueNinetyNineCentDevicePromo)) return promoDeviceRate;
    return _.get(hwcPromoDeviceRates, deviceName, 0);
  };

  const getHwcPromoLabel = device =>
    [
      devicePolycomVVX150,
      deviceYealinkT34W,
      deviceYealinkT34WOld,
      deviceYealinkT33G,
      deviceYealinkT33GOld
    ].includes(device.name)
      ? `- ${hwcPromoLabel}`
      : hwcPromoLabel;

  const getDeviceName = device => {
    if (device === deviceYealinkT48U) return deviceYealinkT48UOld;
    return device;
  };

  const replaceDeviceWithPromo = (promo, device) => {
    const devicePromoLabel = promo.includes(valueNinetyNineCentDevicePromo)
      ? promoLabel
      : getHwcPromoLabel(device);
    const devicePromoRate = getDevicePromoPrices(promo, device.name);
    return {
      ...device,
      name: `${getDeviceName(device.name)} ${devicePromoLabel}`,
      payForDevice: valuePaymentUpfront,
      oneTimeCharges: devicePromoRate,
      unitPrice: devicePromoRate,
      paymentType: paymentTypeUpfront,
      promoApplied: true,
      oldData: device
    };
  };

  const handleClose = () => {
    // Clear seat validation error when modal is closed
    if (formErrors.seatValidation) {
      setFormErrors({
        ...formErrors,
        seatValidation: null
      });
    }
    onClose();
  };

  const onSubmit = () => {
    const errors = getErrors();

    if (typeof errors === 'undefined') return;

    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      if (orderData.type === 'BA') {
        const businessAppPlans = formFields[keyBusinessAppPlans] || [];
        const {
          googleProductEditionsBA,
          microsoftProductEditionsBA,
          esChatProductEditionsBA,
          termProductBA,
          quantity
        } = modalFormFields;

        let selectedProduct;
        if (orderData.productInOrderFor.includes(googleWorkspace))
          selectedProduct = googleProductEditionsBA;
        else if (orderData.productInOrderFor.includes(microsoft365))
          selectedProduct = microsoftProductEditionsBA;
        else selectedProduct = esChatProductEditionsBA;

        const term = _.get(termProductBA, 'value', '');

        let oneTimeCharge = 0;
        let monthlyCharge = 0;
        let annualCharge = 0;

        if (term === valueUpfront) {
          oneTimeCharge =
            selectedProduct && selectedProduct.price
              ? selectedProduct.price
              : 0;
        } else if (term === value12Upfront) {
          oneTimeCharge =
            selectedProduct && selectedProduct.price12
              ? selectedProduct.price12
              : 0;
        } else if (term === value36Upfront) {
          oneTimeCharge =
            selectedProduct && selectedProduct.price36
              ? selectedProduct.price36
              : 0;
        } else if (term === value36Monthly) {
          monthlyCharge =
            selectedProduct && selectedProduct.monthlyPayment36
              ? selectedProduct.monthlyPayment36
              : 0;
        } else if (term === value24Monthly) {
          monthlyCharge =
            selectedProduct && selectedProduct.monthlyPayment24
              ? selectedProduct.monthlyPayment24
              : 0;
        } else if (term === value12Monthly) {
          monthlyCharge =
            selectedProduct && selectedProduct.monthlyPayment12
              ? selectedProduct.monthlyPayment12
              : 0;
        } else {
          monthlyCharge =
            selectedProduct && selectedProduct.monthlyPayment
              ? selectedProduct.monthlyPayment
              : 0;
        }

        if (term === value36Annual) {
          annualCharge =
            selectedProduct && selectedProduct.annualPayment36
              ? selectedProduct.annualPayment36
              : 0;
        }

        const newPlan = {
          name: selectedProduct.value,
          monthlyCharges: monthlyCharge || annualCharge,
          oneTimeCharges: oneTimeCharge,
          term,
          quantity: Number(quantity.value)
        };

        businessAppPlans.push(newPlan);
        setFormFields({
          ...formFields,
          [businessAppPlans]: businessAppPlans
        });

        setDueNow(dueNow + newPlan.oneTimeCharges * newPlan.quantity);
        setDueMonthly(dueMonthly + newPlan.monthlyCharges * newPlan.quantity);
      } else {
        const devices = formFields[key] || [];
        const { device, payment, quantity } = modalFormFields;
        let newDevice = {
          name: device.value,
          payForDevice: payment.value,
          paymentType:
            payment.value === valuePaymentUpfront
              ? paymentTypeUpfront
              : paymentTypeEasyPayment,
          quantity: Number(quantity.value),
          unitPrice:
            payment.value === valuePaymentUpfront
              ? device.price
              : device.monthlyPayment,
          monthlyCharges: device.monthlyPayment,
          oneTimeCharges: device.price,
          ...(key === keyDevices && {
            hwcEligible: Boolean(device.hwcEligible)
          })
        };
        const valuePromotionCode =
          formFields[fieldAvailableDiscountsAndPromotions].value || [];

        // If $0.99 promo or Hardware Credit promo is selected replace the regular device with promo device
        if (
          key === keyDevices &&
          ((valuePromotionCode.includes(valueNinetyNineCentDevicePromo) &&
            [devicePolycomVVX250, deviceCisco7841].includes(device.value)) ||
            (valuePromotionCode.includes(valueHardwareCreditPromo) &&
              [
                devicePolycomVVX150,
                devicePolycomVVX250,
                deviceYealinkT48U,
                deviceYealinkT34W,
                deviceYealinkT33G
              ].includes(device.value)))
        ) {
          const newPromoDevice = replaceDeviceWithPromo(
            valuePromotionCode,
            newDevice
          );
          newDevice = { ...newPromoDevice };
        }

        // Check if this device already exists (same name and payment method)
        const existingDeviceIndex = devices.findIndex(
          i =>
            i.name === newDevice.name &&
            i.payForDevice === newDevice.payForDevice
        );

        // Block a save that would take Upfront HWC devices past the HWC allowance
        if (
          key === keyDevices &&
          newDevice.hwcEligible &&
          newDevice.payForDevice === valuePaymentUpfront
        ) {
          const existingLine =
            existingDeviceIndex >= 0 ? devices[existingDeviceIndex] : null;
          const isExistingLineHwc = Boolean(
            existingLine &&
              existingLine.hwcEligible &&
              existingLine.payForDevice === valuePaymentUpfront
          );
          const hwcCheck = checkHwcAllowance(formFields, orderData, hwcContext, {
            additionalQuantity: newDevice.quantity,
            replacingQuantity: isExistingLineHwc ? existingLine.quantity : 0
          });

          if (hwcCheck.wouldExceed) {
            setFormErrors({
              ...formErrors,
              seatValidation: {
                text: stringInterpolation(
                  maxHwcDevicesErrorMessage,
                  Math.max(
                    0,
                    hwcCheck.allowance -
                      (hwcCheck.current -
                        (isExistingLineHwc ? existingLine.quantity : 0))
                  )
                )
              }
            });
            return;
          }
        }

        // Check seat-based validation for both primary and spare devices
        if (key === keyDevices || key === keySpareDevices) {
          try {
            const maxDevices = calculateMaxDevices(formFields, orderData);
            const currentDevices = calculateCurrentDevices(formFields);

            let currentTotalDevices;
            try {
              // For spare devices, we need to include the current device being added in the calculation
              if (key === keySpareDevices) {
                const currentSpareDevices = (
                  formFields[keySpareDevices] || []
                ).reduce((acc, item) => acc + (item.quantity || 0), 0);
                currentTotalDevices = currentDevices + currentSpareDevices;
              } else {
                currentTotalDevices = calculateCurrentTotalDevices(formFields);
              }
            } catch (error) {
              currentTotalDevices = currentDevices; // Fallback to just current devices
            }
            const maxTotalDevices = maxDevices * 4; // Spare devices can be up to 4x the seat count
            const newQuantity = newDevice.quantity;

            let totalDevicesAfterAdd;
            if (key === keyDevices) {
              // For primary devices, check against seat limit
              if (existingDeviceIndex >= 0) {
                const existingQuantity = devices[existingDeviceIndex].quantity;
                totalDevicesAfterAdd =
                  currentDevices - existingQuantity + newQuantity;
              } else {
                totalDevicesAfterAdd = currentDevices + newQuantity;
              }

              if (totalDevicesAfterAdd > maxDevices) {
                const availableSlots = maxDevices - currentDevices;
                setFormErrors({
                  ...formErrors,
                  seatValidation: {
                    text: `Cannot add ${newQuantity} devices. You can only add ${availableSlots} more devices (${currentDevices}/${maxDevices} total).`
                  }
                });
                return;
              }
            } else if (key === keySpareDevices) {
              // For spare devices, check against total device limit (4x seat count)
              if (existingDeviceIndex >= 0) {
                const existingQuantity = devices[existingDeviceIndex].quantity;
                totalDevicesAfterAdd =
                  currentTotalDevices - existingQuantity + newQuantity;
              } else {
                totalDevicesAfterAdd = currentTotalDevices + newQuantity;
              }

              if (totalDevicesAfterAdd > maxTotalDevices) {
                const availableSlots = maxTotalDevices - currentTotalDevices;
                setFormErrors({
                  ...formErrors,
                  seatValidation: {
                    text: `Cannot add ${newQuantity} spare devices. You can only add ${availableSlots} more total devices (${currentTotalDevices}/${maxTotalDevices} total).`
                  }
                });
                return;
              }
            }
          } catch (error) {
            // Continue with device addition even if seat validation fails
          }
        }

        // Add or update device
        if (existingDeviceIndex >= 0) {
          // Update existing device
          devices[existingDeviceIndex] = newDevice;
        } else {
          // Add new device
          devices.push(newDevice);
        }

        setFormFields({
          ...formFields,
          [key]: devices,
          [keyDevicesWereChanged]: true
        });
        setIsFormTouched(true);
        setIsFormValidated(false);

        // Clear seat validation error on successful submission
        if (formErrors.seatValidation) {
          setFormErrors({
            ...formErrors,
            seatValidation: null
          });
        }

        // Update totals
        if (newDevice.payForDevice === valuePaymentUpfront)
          setDueNow(dueNow + newDevice.oneTimeCharges * newDevice.quantity);
        else
          setDueMonthly(
            dueMonthly + newDevice.monthlyCharges * newDevice.quantity
          );
      }
      handleClose();
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const getUpdatedOptions = (field, removableOptions) => {
    const tempField = field.fields.options.filter(
      item => !removableOptions.includes(item.fields.value)
    );
    return tempField;
  };

  const getValue = (name, value) =>
    modalFormFields && modalFormFields[name] && modalFormFields[name][value];

  // Primary devices only; spare devices never consume the HWC allowance
  const hwcAllowance =
    key === keyDevices && orderData.type !== 'BA'
      ? checkHwcAllowance(formFields, orderData, hwcContext)
      : null;
  const hasHwcOptions = filteredDeviceOptions.some(
    option => option.fields.hwcEligible
  );

  return (
    <ModalCustom
      open={open}
      header={header}
      setOpen={handleClose}
      customStyles="overflow-y: auto; height: auto; overflow-x: hidden"
    >
      <ModalFormWrapper>
        {fields &&
          fields.map(item => {
            const {
              fields: { type, name }
            } = item;
            let updatedOptions = item.fields.options || [];

            /**
             * Use filtered devices from API instead of Contentful options
             */
            if (name === 'device') {
              // Use filtered devices from API
              updatedOptions = filteredDeviceOptions;
            }
            if (name === fieldProductNameBA) {
              if (orderData.productInOrderFor.includes(googleWorkspace)) {
                if (
                  formFields.orderRequestTypeBA.value &&
                  formFields.orderRequestTypeBA.value.includes(
                    existingAppService
                  )
                ) {
                  updatedOptions = getUpdatedOptions(item, [
                    microsoft365,
                    esChat
                  ]);
                } else {
                  updatedOptions = getUpdatedOptions(item, [
                    microsoft365,
                    esChat,
                    appHelpValueAddedService
                  ]);
                }
              } else if (orderData.productInOrderFor.includes(microsoft365)) {
                if (
                  formFields.orderRequestTypeBA.value &&
                  formFields.orderRequestTypeBA.value.includes(
                    existingAppService
                  )
                ) {
                  updatedOptions = getUpdatedOptions(item, [
                    googleWorkspace,
                    googleWorkspaceBusiness,
                    googleWorkspaceEnterprise,
                    googleWorkspaceFrontline,
                    googleWorkspaceEducation,
                    googleWorkspaceAddons,
                    esChat
                  ]);
                } else {
                  updatedOptions = getUpdatedOptions(item, [
                    googleWorkspace,
                    googleWorkspaceBusiness,
                    googleWorkspaceEnterprise,
                    googleWorkspaceFrontline,
                    googleWorkspaceEducation,
                    googleWorkspaceAddons,
                    esChat,
                    appHelpValueAddedService
                  ]);
                }
              } else {
                updatedOptions = getUpdatedOptions(item, [
                  googleWorkspace,
                  googleWorkspaceBusiness,
                  googleWorkspaceEnterprise,
                  googleWorkspaceFrontline,
                  googleWorkspaceEducation,
                  googleWorkspaceAddons,
                  microsoft365,
                  appHelpValueAddedService
                ]);
              }
            }

            const valueProductNameBA =
              (modalFormFields &&
                modalFormFields.productNameBA &&
                modalFormFields.productNameBA.value) ||
              null;

            if (name === fieldGoogleProductEditionsBA && valueProductNameBA) {
              let removable = [];

              if (valueProductNameBA === googleWorkspaceBusiness) {
                removable = [
                  ...googleEnterpriseOptions,
                  ...googleFrontlineOptions,
                  ...googleEducationOptions,
                  ...googleAddonsOptions,
                  ...nonGoogleOptions
                ];
              } else if (valueProductNameBA === googleWorkspaceEnterprise) {
                removable = [
                  ...googleBusinessOptions,
                  ...googleFrontlineOptions,
                  ...googleEducationOptions,
                  ...googleAddonsOptions,
                  ...nonGoogleOptions
                ];
              } else if (valueProductNameBA === googleWorkspaceFrontline) {
                removable = [
                  ...googleBusinessOptions,
                  ...googleEnterpriseOptions,
                  ...googleEducationOptions,
                  ...googleAddonsOptions,
                  ...nonGoogleOptions
                ];
              } else if (valueProductNameBA === googleWorkspaceEducation) {
                removable = [
                  ...googleBusinessOptions,
                  ...googleEnterpriseOptions,
                  ...googleFrontlineOptions,
                  ...googleAddonsOptions,
                  ...nonGoogleOptions
                ];
              } else if (valueProductNameBA === googleWorkspaceAddons) {
                removable = [
                  ...googleBusinessOptions,
                  ...googleEnterpriseOptions,
                  ...googleFrontlineOptions,
                  ...googleEducationOptions,
                  ...nonGoogleOptions
                ];
              } else {
                removable = [
                  ...googleBusinessOptions,
                  ...googleEnterpriseOptions,
                  ...googleFrontlineOptions,
                  ...googleEducationOptions,
                  ...googleAddonsOptions
                ];
              }

              updatedOptions = getUpdatedOptions(item, removable);
            }

            if (name === fieldMicrosoftProductEditionsBA) {
              if (valueProductNameBA) {
                const categories = _.get(fields, '[0].fields.options', []).map(
                  i => i.fields.value
                );
                if (valueProductNameBA === microsoft365) {
                  updatedOptions = getUpdatedOptions(item, nonMicrosoftOptions);
                } else if (categories.includes(+valueProductNameBA)) {
                  updatedOptions = updatedOptions.filter(
                    option =>
                      option.fields.productCategoryId === +valueProductNameBA
                  );
                } else {
                  updatedOptions = updatedOptions.filter(option =>
                    nonMicrosoftOptions.includes(option.fields.value)
                  );
                }
              }
            }

            if (
              [
                fieldGoogleProductEditionsBA,
                fieldMicrosoftProductEditionsBA,
                fieldESChatProductEditionsBA
              ].includes(name) &&
              !_.get(modalFormFields, 'productNameBA.value', '')
            )
              updatedOptions = [];

            if (name === fieldTermProductBA) {
              if (
                ![microsoft365, googleWorkspace].includes(
                  valueBAProductSelected
                )
              )
                return null;
              const valueGoogleEditions = _.get(
                modalFormFields,
                `${fieldGoogleProductEditionsBA}.value`,
                ''
              );
              const valueMicrosoftEditions = _.get(
                modalFormFields,
                `${fieldMicrosoftProductEditionsBA}.value`,
                ''
              );
              const valueEsChatEditions = _.get(
                modalFormFields,
                `${fieldESChatProductEditionsBA}.value`,
                ''
              );

              if (
                !valueGoogleEditions &&
                !valueMicrosoftEditions &&
                !valueEsChatEditions
              )
                updatedOptions = [];
              if (
                valueGoogleEditions ||
                valueMicrosoftEditions ||
                valueEsChatEditions
              ) {
                const {
                  price,
                  monthlyPayment,
                  price12,
                  monthlyPayment12,
                  monthlyPayment24,
                  price36,
                  annualPayment36,
                  monthlyPayment36
                } = _.get(
                  modalFormFields,
                  valueBAProductSelected === microsoft365
                    ? fieldMicrosoftProductEditionsBA
                    : fieldGoogleProductEditionsBA,
                  {}
                );
                const isNotNumber = value =>
                  value === undefined || value === null;

                if (isNotNumber(price))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== valueUpfront
                  );
                if (isNotNumber(monthlyPayment))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== valueMonthly
                  );
                if (isNotNumber(price12))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value12Upfront
                  );
                if (isNotNumber(monthlyPayment12))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value12Monthly
                  );
                if (isNotNumber(monthlyPayment24))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value24Monthly
                  );
                if (isNotNumber(price36))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value36Upfront
                  );
                if (isNotNumber(annualPayment36))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value36Annual
                  );
                if (isNotNumber(monthlyPayment36))
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value36Monthly
                  );
                if (updatedOptions.length === 0) return null;
              }
            }

            /**
             * Showing only those payment options
             * that the selected device supports
             */
            if (
              name === 'payment' &&
              _.get(modalFormFields, 'device.value', '')
            ) {
              updatedOptions = item.fields.options.filter(data => {
                const upfront = _.get(modalFormFields, 'device.price', 0);
                const monthly = _.get(
                  modalFormFields,
                  'device.monthlyPayment',
                  0
                );
                return (
                  (data.fields.value === valuePaymentUpfront &&
                    upfront !== 0) ||
                  (data.fields.value === valueEasyPayment && monthly !== 0)
                );
              });
            }

            const data = {
              ...item.fields,
              options: updatedOptions,
              ref: getValue(name, 'ref'),
              onChange
            };

            let result;
            let error;

            if (name === fieldPayment) {
              data.disabled = key === keySpareDevices;
              data.hideEmptyValue = true;
              if (isPaymentLocked) {
                data.options = data.options.filter(
                  o => o.fields.value === valuePaymentUpfront
                );
              }
            }
            if (
              formErrors &&
              Object.prototype.hasOwnProperty.call(formErrors, name)
            ) {
              error = formErrors[name];
            }

            switch (type) {
              case 'Text':
              case 'Number':
                result = <Input data={data} />;
                break;
              case 'Select':
                // Show loading indicator for device field when loading devices
                if (name === 'device' && isLoadingDevices) {
                  result = (
                    <div style={{ padding: '10px', textAlign: 'center' }}>
                      Loading devices...
                    </div>
                  );
                } else if (
                  name === 'device' &&
                  !isLoadingDevices &&
                  filteredDeviceOptions.length === 0
                ) {
                  // Show message when no devices are available
                  // Compare with modalFormDevices to work with both English and French
                  const isSpareDevices = header !== modalFormDevices;
                  const message = isSpareDevices
                    ? 'No spare devices available. You may have reached the device limit (4x your seat count) or no devices support spare devices for your configuration.'
                    : 'No devices available. You may have reached the device limit (equal to your seat count) or no devices match your configuration.';

                  result = (
                    <div
                      style={{
                        padding: '10px',
                        textAlign: 'center',
                        color: '#666',
                        fontStyle: 'italic'
                      }}
                    >
                      {message}
                    </div>
                  );
                } else {
                  result = <Select data={data} />;
                }
                break;
              default:
                result = null;
            }

            return (
              <Fragment key={name}>
                {result}
                {error && <Error text={error.text} />}
              </Fragment>
            );
          })}

        {/* Display remaining Hardware Credit allowance */}
        {hwcAllowance &&
          ((hasHwcOptions && hwcAllowance.remaining > 0) ||
            (hwcAllowance.remaining === 0 && hwcAllowance.current > 0)) && (
            <div
              style={{
                margin: '10px 0',
                textAlign: 'center',
                fontSize: '14px',
                color: '#4B286D'
              }}
            >
              {hwcAllowance.remaining > 0
                ? stringInterpolation(
                    maxHwcDevicesErrorMessage,
                    hwcAllowance.remaining
                  )
                : hwcAllowanceExhaustedMessage}
            </div>
          )}

        {/* Display seat validation error */}
        {formErrors.seatValidation && (
          <ErrorMessage type="text" text={formErrors.seatValidation.text} />
        )}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="button"
            onPress={onSubmit}
            variant={{ priority: 'high' }}
          >
            {saveButtonLabel}
          </Button>
        </div>
      </ModalFormWrapper>
    </ModalCustom>
  );
};

ModalForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formFields: PropTypes.objectOf(PropTypes.any),
  setFormFields: PropTypes.func,
  dueNow: PropTypes.number.isRequired,
  setDueNow: PropTypes.func.isRequired,
  dueMonthly: PropTypes.number.isRequired,
  setDueMonthly: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.func.isRequired,
  setIsFormValidated: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

ModalForm.defaultProps = {
  formFields: [],
  setFormFields: () => {}
};

export default ModalForm;
